// extracted by mini-css-extract-plugin
export default {"payment-submit-button":"styles__payment-submit-button--PE-IJ"};